import { render, staticRenderFns } from "./DesgloseIMSS.vue?vue&type=template&id=108a85dc&scoped=true"
import script from "./DesgloseIMSS.vue?vue&type=script&lang=js"
export * from "./DesgloseIMSS.vue?vue&type=script&lang=js"
import style0 from "./DesgloseIMSS.vue?vue&type=style&index=0&id=108a85dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a85dc",
  null
  
)

export default component.exports